import React from "react";
import { instanceOf, string } from "prop-types";
import FormattedAmount from "pages/_components/FormattedAmount";
import * as i18n from "util/i18n";

const SummaryActions = ({ list, currency, className }) => {
    let totalAmount = 0;

    list.forEach((object) => {
        const amount = object?.amount?.quantity || object.monto;
        totalAmount += parseFloat(amount, 10) > 0 && parseFloat(amount, 10);
    });

    return (
        <h2 className={className}>
            {list.length === 1 && (
                <>
                    <span>Nº</span>
                    <span className="echeq-number">{` ${list[0].cheque_numero}`}</span>
                </>
            )}
            <span>{i18n.get("transaction.process.details.heading.totalAmount")} </span>
            <FormattedAmount currency={currency} quantity={totalAmount} />
            {list.length > 1 && <p>{i18n.get("echecks.operations").concat(" ", list.length)}</p>}
        </h2>
    );
};

SummaryActions.propTypes = {
    list: instanceOf(Array).isRequired,
    currency: string,
    className: string,
};

SummaryActions.defaultProps = {
    currency: "ARS",
    className: "",
};

export default SummaryActions;
